import React, { useMemo } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { useIsStandard } from '@contexts/operator/PlanContext';
import Can from '@shared/permissions/Can';
import ProductLabelTemplatesList from '@shared/product_label_templates/ProductLabelTemplatesList';
import ListPageHeader from '@shared/ListPageHeader';

import { productLabelTemplateService } from '@services/operator/productLabelTemplateService';

interface MerchantOption {
  label: string;
  value: string;
  [key: string]: unknown;
}

const OperatorProductLabelTemplatesList: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // OperatorDataContext / PlanContext 為 .jsx 無型別，cast 為 any 保留 runtime 行為。
  const { merchants } = useOperatorData() as any;
  const isStandard = useIsStandard() as boolean;

  const merchantOptions = useMemo<MerchantOption[]>(() => {
    return (merchants as Array<{ id: string; name: string }>).map((merchant) => ({
      label: merchant.name,
      value: merchant.id,
    }));
  }, [merchants]);

  return (
    <div>
      <ListPageHeader
        items={['products', 'products.label_templates']}
        actions={
          <Can requiredPermission="products:write">
            <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/product_label_templates/new')}>
              {t('common.button.new')}
            </Button>
          </Can>
        }
      />
      <ProductLabelTemplatesList
        service={productLabelTemplateService}
        role="operator"
        merchantOptions={merchantOptions}
        hideMerchantUI={isStandard}
      />
    </div>
  );
};

export default OperatorProductLabelTemplatesList;
